export default "__VITE_ASSET__CdSzfL0c__"